import { render, staticRenderFns } from "./PopoverModalPost.vue?vue&type=template&id=3d1d10e9&"
import script from "./PopoverModalPost.vue?vue&type=script&lang=js&"
export * from "./PopoverModalPost.vue?vue&type=script&lang=js&"
import style0 from "./PopoverModalPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports